<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">DNEVNI IZVJEŠTAJ O ZAVRŠENIM RADNIM NALOZIMA</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
    </div>

    <div class="customTable pregledIzdatnica">
      <dx-data-grid
        id="izvjestajZRN"
        [dataSource]="izvjestaji"
        [wordWrapEnabled]="true"
        keyExpr="idplanproizvodnje"
        [showColumnLines]="true"
        [showBorders]="false"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        (onExporting)="onExporting($event)"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="dohvatiOdstupanja($event)"
        (onRowClick)="onRowClick($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Dnevni izvještaji završenih radnih naloga</h2>
            <p class="mt-0">Kliknite na nalog za prikaz detalja</p>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-export [enabled]="dozvoli_export" fileName="izvjestaj_o_zavrsenim_rn"></dxo-export>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxi-column
          dataField="datumplana"
          dataType="date"
          caption="Datum"
          [width]="160"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="idplanproizvodnje"
          caption="Plan"
          [width]="80"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="li_naziv"
          caption="Linija"
          [width]="250"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="smjena_idsmjena"
          caption="Smjena"
          [width]="120"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="brojnaloga"
          caption="Broj RN"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="datumivrijemepocetka"
          caption="Početak RN"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="datumivrijemezavrsetka"
          caption="Završetak RN"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ar_sifra"
          caption="Šifra artikla"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Naziv artikla"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ostvarenakolicina"
          caption="Ostvarena količina"
          alignment="right"
          [visible]="false"
          [allowExporting]="true"
        ></dxi-column>
        <dxi-column
          dataField="planiranakolicina"
          caption="Planirana količina"
          alignment="right"
          [visible]="false"
          [allowExporting]="true"
        ></dxi-column>
        <dxi-column
          dataField="razlikaukomadima"
          caption="Razlika u kom"
          alignment="right"
          [visible]="false"
          [allowExporting]="true"
        ></dxi-column>
        <dxi-column
          dataField="postotakdesktop"
          caption="Ostvareno u %"
          alignment="right"
          [visible]="false"
          [allowExporting]="true"
        ></dxi-column>
        <dxi-column
          dataField="rns_skart"
          caption="Škart"
          alignment="right"
          [visible]="false"
          [allowExporting]="true"
        ></dxi-column>
        <dxi-column
          dataField="dobarproizvod"
          caption="Dobar proizvod"
          alignment="right"
          [visible]="false"
          [allowExporting]="true"
        ></dxi-column>
        <dxi-column caption="Check lista" cellTemplate="pdf" alignment="center" [allowExporting]="false">
          <div *dxTemplate="let data of 'pdf'">
            <!-- <dx-button *ngIf="data.data.checklista_idchecklista" hint="Check lista PDF" icon="pdffile"></dx-button> -->
            <a *ngIf="data.data.checklista_idchecklista" class="cl_pdf" href="{{URL}}/datoteke_server/URL={{data.data.cl_putanjaPDF}}?access_token={{token}}" target="_blank" title="Check lista PDF"><i class="dx-icon dx-icon-pdffile"></i></a>
          </div>
        </dxi-column>
        <dxo-master-detail
          [enabled]="false"
          template="detail"
        ></dxo-master-detail>

        <div *dxTemplate="let data of 'detail'">
          <p *ngIf="podaciPlan.length == 0">Dohvaćanje podataka...</p>
          <div *ngIf="podaciPlan.length > 0">
            <!-- ? KOLIČINA PLAN -->
            <div class="plan_kolicina">
              <p style="margin: 0 0 0.5rem">Količina:</p>
              <dx-tree-list
                [dataSource]="podaciPlan"
                [wordWrapEnabled]="true"
                keyExpr="idplanproizvodnje"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="ostvarenakolicina"
                  caption="Ostvarena količina"
                ></dxi-column>
                <dxi-column
                  dataField="planiranakolicina"
                  caption="Planirana količina"
                ></dxi-column>
                <dxi-column
                  dataField="razlikaukomadima"
                  caption="Razlika u kom"
                ></dxi-column>
                <!-- <dxi-column
                dataField="razlikaupostocimakolicina"
                caption="Razlika u %"
              ></dxi-column> -->
                <dxi-column
                  dataField="postotakdesktop"
                  caption="Ostvareno u %"
                ></dxi-column>
                <dxi-column dataField="rns_skart" caption="Škart"></dxi-column>
                <dxi-column dataField="dobarproizvod" caption="Dobar proizvod"></dxi-column>
              </dx-tree-list>
            </div>

            <!-- ? PROCESI VRIJEME -->
            <div class="procesi_vrijeme">
              <p style="margin: 1rem 0 0.5rem">Vrijeme (minuta):</p>
              <dx-tree-list
                [dataSource]="procesiVrijeme"
                [wordWrapEnabled]="true"
                keyExpr="ostvarenovrijemeproizvodnje"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="ostvarenovrijemeproizvodnje"
                  caption="Ostvareno vrijeme"
                ></dxi-column>
                <dxi-column
                  dataField="planiranovrijemeproizvodnje"
                  caption="Planirano vrijeme"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjemin"
                  caption="Razlika u min"
                ></dxi-column>
                <dxi-column
                  dataField="razlikaupostocima"
                  caption="Razlika u %"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!-- ? PROCESI -->
            <div class="procesi">
              <p style="margin: 1rem 0 0.5rem">Procesi:</p>
              <dx-tree-list
                [dataSource]="procesi"
                [wordWrapEnabled]="true"
                keyExpr="ps_naziv"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="ps_naziv"
                  caption="Naziv"
                  [width]="250"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjevrijemetrajanjaoperacije"
                  caption="Odstupanje trajanja operacije (min)"
                ></dxi-column>
                <dxi-column
                  dataField="razlikaupostocimavrijemetrajanjaoperacije"
                  caption="Odstupanje trajanja operacije (%)"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjevrijemetrajanjacijelogprocesa"
                  caption="Odstupanje trajanja cijelog procesa (min)"
                ></dxi-column>
                <dxi-column
                  dataField="razlikaupostocimavrijemetrajanjacijelogprocesa"
                  caption="Odstupanje trajanja cijelog procesa (%)"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjebrojradnikanaoperaciji"
                  caption="Odstupanje broja radnika na operaciji"
                ></dxi-column>
                <dxi-column
                  dataField="razlikaupostocimabrojradnikanaoperaciji"
                  caption="Odstupanje broja radnika na operaciji (%)"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!-- ? STROJEVI -->
            <div class="strojevi">
              <p style="margin: 1rem 0 0.5rem">Strojevi:</p>
              <dx-tree-list
                [dataSource]="strojevi"
                [wordWrapEnabled]="true"
                keyExpr="st_sifra"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="st_sifra"
                  caption="Šifra"
                  [width]="100"
                ></dxi-column>
                <dxi-column
                  dataField="st_naziv"
                  caption="Naziv"
                  [width]="250"
                ></dxi-column>
                <dxi-column
                  caption="Potrošnja plina (planirano/stvarno)"
                  [calculateCellValue]="plinPlaniranoStvarno"
                ></dxi-column>
                <dxi-column
                  caption="Potrošnja struje (planirano/stvarno)"
                  [calculateCellValue]="strujaPlaniranoStvarno"
                ></dxi-column>
                <dxi-column
                  caption="Potrošnja vode (planirano/stvarno)"
                  [calculateCellValue]="vodaPlaniranoStvarno"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjeamortizacija"
                  caption="Odstupanje amortizacije"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjepotrosnjaplina"
                  caption="Odstupanje potrošnje plina"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjepotrosnjastrujenastroju"
                  caption="Odstupanja potrošnje struje"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanjepotrosnjavode"
                  caption="Odstupanje potrošnje vode"
                ></dxi-column>
                <dxi-column
                  dataField="pis_ukupanplinukn"
                  caption="Ukupno plin (kn)"
                ></dxi-column>
                <dxi-column
                  dataField="pis_ukupnastrujaukn"
                  caption="Ukupno struja (kn)"
                ></dxi-column>
                <dxi-column
                  dataField="pis_ukupnovodaukn"
                  caption="Ukupno voda (kn)"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!-- ? NORMATIVI -->
            <div class="normativi">
              <p style="margin: 1rem 0 0.5rem">Normativi:</p>
              <dx-tree-list
                [dataSource]="normativi"
                [wordWrapEnabled]="true"
                keyExpr="ar_naziv"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="100"
              >
                <dxi-column
                  dataField="ar_naziv"
                  caption="Naziv artikla"
                  [width]="200"
                ></dxi-column>
                <dxi-column
                  dataField="ns_kolicina_edit"
                  caption="Stvarno"
                ></dxi-column>
                <dxi-column
                  dataField="ns_kolicina"
                  caption="Planirano"
                ></dxi-column>
                <dxi-column
                  dataField="odstupanje"
                  caption="Odstupanje"
                ></dxi-column>
                <dxi-column
                  dataField="razlikaupostocima"
                  caption="Razlika u %"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!-- ? DJELATNICI PLAN -->
            <div class="djelatnici_plan">
              <p style="margin: 1rem 0 0.5rem">
                Djelatnici planirano: (Ukupno planirano vrijeme u minutama:
                {{ planiranoVrijeme }})
              </p>
              <dx-tree-list
                [dataSource]="djelatniciPlan"
                [wordWrapEnabled]="true"
                keyExpr="dp_djelatnik"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="dp_djelatnik"
                  caption="Djelatnik"
                  [width]="500"
                ></dxi-column>
                <dxi-column
                  dataField="dp_vrijemeod"
                  caption="Od"
                  [width]="100"
                ></dxi-column>
                <dxi-column
                  dataField="dp_vrijemedo"
                  caption="Do"
                  [width]="100"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!-- ? DJELATNICI OSTVARENO -->
            <div class="djelatnici_plan">
              <p style="margin: 1rem 0 0.5rem">
                Djelatnici ostvareno: (Ukupno ostvareno vrijeme u minutama:
                {{ ostvarenoVrijeme }})
              </p>
              <dx-tree-list
                [dataSource]="djelatniciOstvareno"
                [wordWrapEnabled]="true"
                keyExpr="dp_djelatnik"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="dp_djelatnik"
                  caption="Djelatnik"
                  [width]="500"
                ></dxi-column>
                <dxi-column
                  dataField="dp_vrijemeod"
                  caption="Od"
                  [width]="100"
                ></dxi-column>
                <dxi-column
                  dataField="dp_vrijemedo"
                  caption="Do"
                  [width]="100"
                ></dxi-column>
                <dxi-column
                  dataField="vrijemeradauminutama"
                  caption="Vrijeme rada u minutama"
                  [width]="100"
                ></dxi-column>
                <dxi-column
                  dataField="dp_napomena"
                  caption="Napomena"
                  [minWidth]="200"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!--OTP-->
            <div class="otp">
              <p style="margin: 1rem 0 0.5rem">OTP</p>
              <dx-tree-list
                [dataSource]="otp"
                [wordWrapEnabled]="true"
                [showBorders]="true"
                keyExpr="idostalitroskoviproizvodnje"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="otp_nazivdodatka"
                  caption="Naziv dodatka"
                  [width]="300"
                ></dxi-column>
                <dxi-column
                  dataField="ps_naziv"
                  caption="Proces"
                  [width]="300"
                ></dxi-column>
                <dxi-column
                  dataField="st_naziv"
                  caption="Stroj"
                  [width]="300"
                ></dxi-column>
                <dxi-column
                  dataField="otp_ukupnododatak"
                  caption="Ukupno dodatak"
                  [width]="200"
                ></dxi-column>
                <dxi-column
                  dataField="otp_cijenadodatkapomin"
                  caption="Cijena dodatka po minuti"
                  [width]="200"
                ></dxi-column>
                <dxi-column
                  dataField="otp_ukupnoekstradodatak"
                  caption="Ukupno ekstra dodatak"
                  [width]="200"
                ></dxi-column>
                <dxi-column
                  dataField="otp_napomena"
                  caption="Napomena"
                  [minWidth]="250"
                ></dxi-column>
              </dx-tree-list>
            </div>

            <!-- SLIKE -->
            <div class="slike">
              <p style="margin: 1rem 0 0.5rem">Slike</p>
              <dx-tree-list
                [dataSource]="sviDokumenti"
                [wordWrapEnabled]="true"
                [showBorders]="true"
                keyExpr="iduploaddokument"
                [columnAutoWidth]="true"
                [columnWidth]="500"
              >
                <dxi-column
                  dataField="redni_broj"
                  caption="Rb."
                  [width]="100"
                  [formItem]="{ visible: false }"
                  [allowEditing]="false"
                ></dxi-column>

                <dxi-column caption="Naziv" cellTemplate="slikaa">
                  <div *dxTemplate="let data of 'slikaa'">
                    <a
                      class="slika"
                      href="{{
                        URL
                      }}/dokumentiplanskakalkulacija/planskakalkulacija/URL={{
                        data.data.ud_putanja
                      }}?access_token={{ token }}"
                      target="_blank"
                      title="Pogledaj"
                      >{{ data.data.ud_nazivdokumenta_orig }}</a
                    >
                  </div>
                </dxi-column>
              </dx-tree-list>
            </div>

            <!--KOMENTARI-->
            <div class="komentari">
              <p style="margin: 1rem 0 0.5rem">Komentari</p>
              <dx-tree-list
                [dataSource]="napomena_komentar"
                [wordWrapEnabled]="true"
                [showBorders]="true"
                keyExpr="idplanskakalkulacija"
                [columnAutoWidth]="true"
                [columnWidth]="150"
              >
                <dxi-column
                  dataField="pk_napomena"
                  caption="Komentari"
                  [width]="1000"
                ></dxi-column>
              </dx-tree-list>
            </div>
          </div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
